import { render, staticRenderFns } from "./order-item-applicants.vue?vue&type=template&id=f33e68e2&scoped=true"
import script from "./order-item-applicants.vue?vue&type=script&lang=js"
export * from "./order-item-applicants.vue?vue&type=script&lang=js"
import style0 from "./order-item-applicants.vue?vue&type=style&index=0&id=f33e68e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33e68e2",
  null
  
)

export default component.exports